import React from 'react';
import { CheckIcon } from '@heroicons/react/24/solid';

const WorkoutTile = ({
  image,
  title,
  usageCount,
  badgeText = 'Weight Loss',
  status,
  onMenuClick,
  onClick,
  onDelete,
  selectionMode = false,
  isSelected = false,
  onSelect
}) => {
  const handleClick = () => {
    if (selectionMode && onSelect) {
      onSelect();
    } else if (onClick) {
      onClick();
    }
  };

  const imgSize = selectionMode ? 'w-20 h-20' : 'w-[150px] h-[150px]';

  return (
    <div
      className={`bg-white dark:bg-shoorah-darkBgTabColor rounded-lg border shadow-sm hover:shadow-md transition-all cursor-pointer flex items-center p-3 gap-3 relative overflow-hidden ${
        selectionMode && isSelected
          ? 'border-shoorah-primary border-2 bg-indigo-50 dark:bg-indigo-950'
          : 'border-[#E7E8EA] dark:border-shoorah-darkBorder'
      }`}
      onClick={handleClick}
    >
      {/* Selected checkmark indicator (no checkbox, border-only selection with icon) */}
      {selectionMode && isSelected && (
        <div className="absolute top-2 right-2 z-10 bg-shoorah-primary rounded-full p-0.5 shadow">
          <CheckIcon className="w-3.5 h-3.5 text-white" />
        </div>
      )}

      {/* Image Container */}
      <div className={`flex-shrink-0 ${imgSize}`}>
        <img
          src={image || '/placeholder-workout.jpg'}
          alt={title}
          className={`${imgSize} object-cover rounded-lg`}
        />
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0 overflow-hidden">
        <h3 className="text-sm font-semibold text-gray-900 dark:text-white mb-1 line-clamp-2 leading-tight">
          {title}
        </h3>
        <p className="text-xs text-gray-500 dark:text-gray-400 mb-2">
          Used {usageCount?.toLocaleString() || 0} times
        </p>
        {/* Badge */}
        <span className="inline-block max-w-full truncate bg-indigo-600 text-white text-xs font-medium px-3 py-1 rounded-full">
          {badgeText}
        </span>
      </div>

      {/* Status Badge - Show before three dots menu */}
      {!selectionMode && status && (
        <div className="absolute top-3 right-12">
          <span
            className={`inline-block text-xs font-medium px-3 py-1 rounded-full ${
              status === 'published'
                ? 'bg-green-100 text-green-700'
                : 'bg-yellow-100 text-yellow-700'
            }`}
          >
            {status === 'published' ? 'Published' : 'Draft'}
          </span>
        </div>
      )}

      {/* Three Dots Menu - Hide in selection mode */}
      {!selectionMode && (
        <button
          className="absolute top-3 right-3 p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full"
          onClick={(e) => {
            e.stopPropagation();
            onMenuClick?.(e);
          }}
        >
          <svg
            className="w-5 h-5 text-gray-600 dark:text-gray-400"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <circle cx="12" cy="5" r="2" />
            <circle cx="12" cy="12" r="2" />
            <circle cx="12" cy="19" r="2" />
          </svg>
        </button>
      )}
    </div>
  );
};

export default WorkoutTile;
